import * as Yup from "yup";

export const initialValues = (data) => {
  return {
    ...data,
    image: data?.image,
    name_en:
      data?.localized_data?.en?.name || data?.name_en || data?.name || "",
    name_ar: data?.localized_data?.ar?.name || data?.name_ar || "",
    display_priority: data?.display_priority ?? "",
  };
};

export const structure = (_, __, t) => [
  {
    head: "",
    width: "100%",
    list: [
      {
        name: `image`,
        kind: "upload",
        type: "file",
        label: `${t("common.image")}*`,
        width: "100%",
      },
      {
        name: `name_en`,
        kind: "input",
        type: "text",
        label: `${t("lookups_brands.brand_name_en")}*`,
        width: "47%",
      },
      {
        name: `name_ar`,
        kind: "input",
        type: "text",
        label: `${t("lookups_brands.brand_name_ar")}*`,
        width: "47%",
      },
      {
        name: `display_priority`,
        kind: "input",
        type: "number",
        label: t("lookups_brands.display_priority"),
        width: "47%",
      },
    ],
  },
];

export const validationSchema = () =>
  Yup.object({
    name_en: Yup.string().required("Required"),
    name_ar: Yup.string().required("Required"),
    image: Yup.mixed().required("Required"),
    display_priority: Yup.number().typeError("Must be a number").nullable(),
  });
